import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=4fda6223"
import script from "./Collapsible.vue?vue&type=script&lang=ts"
export * from "./Collapsible.vue?vue&type=script&lang=ts"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=4fda6223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports